import { render, staticRenderFns } from "./PaginaComoFunciona.vue?vue&type=template&id=1f625096&scoped=true&"
import script from "./PaginaComoFunciona.vue?vue&type=script&lang=js&"
export * from "./PaginaComoFunciona.vue?vue&type=script&lang=js&"
import style0 from "./PaginaComoFunciona.vue?vue&type=style&index=0&id=1f625096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f625096",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VPagination,VRow})
